import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { PermissionsEnum } from 'api/Identity/Types/PermissionsEnum'
import { AuthSessionContext } from 'utils/AuthContext'
import { links } from 'utils/featureToggles'
import { hasPermission } from 'utils/permissionsValidator'

interface Props {
  tab: AdministrationCountriesTab
}

export enum AdministrationCountriesTab {
  COUNTRIES = 'countries',
  WALLETS = 'wallets',
  TRADING_ACCOUNTS = 'trading-accounts',
  PRODUCTS = 'products',
}

export const AdministrationCountriesNavigation: React.FC<Props> = (props) => {
  const [auth] = useContext(AuthSessionContext)
  const navigate = useNavigate()
  const permissions = auth?.permissions || []

  const handleTabClick = (tab: string) => {
    switch (tab) {
      case AdministrationCountriesTab.COUNTRIES:
        return navigate(links.administrationCountries.url)
      case AdministrationCountriesTab.WALLETS:
        return navigate(links.administrationWallets.url)
      case AdministrationCountriesTab.TRADING_ACCOUNTS:
        return navigate(links.administrationTradingAccounts.url)
      case AdministrationCountriesTab.PRODUCTS:
        return navigate(links.administrationProducts.url)
      default:
        return navigate(links.administrationCountries.url)
    }
  }

  return (
    <div>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={AdministrationCountriesTab.COUNTRIES}>Main</TabsTrigger>

          {hasPermission(permissions, PermissionsEnum.CanViewWalletConfiguration) && (
            <TabsTrigger value={AdministrationCountriesTab.WALLETS}>Wallets</TabsTrigger>
          )}

          {hasPermission(permissions, PermissionsEnum.CanViewTradingAccountConfiguration) && (
            <>
              <TabsTrigger value={AdministrationCountriesTab.TRADING_ACCOUNTS}>
                Trading accounts
              </TabsTrigger>

              <TabsTrigger value={AdministrationCountriesTab.PRODUCTS}>Products</TabsTrigger>
            </>
          )}
        </TabsList>
      </Tabs>
    </div>
  )
}
